/**
 * Created with setting codegen.
 */
import { featureToggle } from "@faire/web--source/common/settings/declarations/featureToggle";

/**
 * Feature toggle to enable click prefetching on PDP
 */
export const FE_PDP_CLICK_PREFETCH_250527 = featureToggle({
  name: "FE_PDP_CLICK_PREFETCH_250527",
  identifier: "RetailerTokenInSession",
  defaultValue: false,
  client: "RETAILER",
  productArea: "PRODUCT_PAGE",
  notifyAfter: "2025-08-27",
});
